import React, { useMemo } from 'react'
import { useSelector } from 'react-redux';
import { getEnvironmentVariableSelector } from '../../slices/designerSlice';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Col, Row } from 'react-bootstrap';
import { Avatar, Flex, Tooltip } from 'antd';
import TextResizer from '../generics/TextResizer';

export default function AgentNodeContent({ data }: any) {
  const getSelectedEnvironmentVariable = useSelector(getEnvironmentVariableSelector);
  const llmModelKey = window.__env.DESIGNER__AGENT_LLM_MODEL_PROPERTY, promptKey = window.__env.DESIGNER__AGENT_PROMPT_PROPERTY;
  const selectedEnvironmentVariable = useMemo(() => getSelectedEnvironmentVariable(data[llmModelKey]), [data, getSelectedEnvironmentVariable, llmModelKey]);

  return (
    <>
      <h6 className="mb-0">
        <FontAwesomeIcon icon={solid('user-secret')} />
        <span className="ms-2">{data.label || data.text}</span>
      </h6>
      {/* to make it work with float: right */}
      <Flex vertical>
        <div className="node-trailing text-truncate">
          <FontAwesomeIcon icon={solid('tag')} />
          <span className="ms-1">{data.version}</span>
        </div>
      </Flex>
      {(data[llmModelKey] !== undefined || data[promptKey] !== undefined) && (
        <Row className="inputs-row gx-2">
          <Col xs="auto">
            <div className={classNames("input-container", { empty: !selectedEnvironmentVariable })}>
              {selectedEnvironmentVariable
                ? (
                  <Flex align="center">
                    <div>
                      <Avatar
                        src={selectedEnvironmentVariable.img}
                        icon={<FontAwesomeIcon icon={solid('image')} />}
                        className="border me-1"
                        style={{ height: 35, width: 35 }}
                      />
                    </div>
                    <Col className="ps-2 overflow-hidden text-truncate">
                      <Tooltip title={selectedEnvironmentVariable.name}>
                        <b className="d-block mb-0 text-truncate">{selectedEnvironmentVariable.name}</b>
                      </Tooltip>
                      <small className="text-muted">{selectedEnvironmentVariable.description}</small>
                    </Col>
                  </Flex>
                )
                : (
                  <>
                    <FontAwesomeIcon icon={solid('plus')} />
                    <span className="ms-2">Choose LLM Model</span>
                  </>
                )}
            </div>
          </Col>
          <Col>
            <div className={classNames("input-container", { empty: !data[promptKey] })}>
              {data[promptKey]
                ? (
                  <Flex align="center">
                    <FontAwesomeIcon icon={solid('terminal')} size="sm" />
                    <TextResizer className="ms-2">{data[promptKey]}</TextResizer>
                  </Flex>
                )
                : (
                  <>
                    <FontAwesomeIcon icon={solid('plus')} />
                    <span className="ms-2">Write Prompt</span>
                  </>
                )}
            </div>
          </Col>
        </Row>
      )}
    </>
  );
}
